import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Route, Redirect, RouteComponentProps } from 'react-router';
import { State } from '../reducers/index';
import { setRedirectURL, clearRedirectURL } from '../actions/user.actions';

interface PrivateRouteProps {
    login: boolean;
    redirectUrl: string;
    routeProps: any;
    token: string;
    dispatch: Dispatch<any>;
}

const mapStatetoProps = (state: State, ownProps: any) => ({
  login: state.authentication.login,
  redirectUrl: state.authentication.redirectURL,
  routeProps: ownProps,
  token: state.authentication.token,
});

class PrivateRoute extends React.Component<PrivateRouteProps, {}> {
  componentDidUpdate(prevProps: PrivateRouteProps) {
    // Handle redirect URL logic in componentDidUpdate to avoid render-time side effects
    if (!this.props.login && this.props.routeProps.location.pathname && 
        this.props.routeProps.location.pathname !== prevProps.routeProps.location.pathname) {
      this.props.dispatch(setRedirectURL(this.props.routeProps.location.pathname));
    }
    
    // Handle clearing redirect URL after successful login
    if (this.props.login && this.props.redirectUrl && !prevProps.login) {
      this.props.dispatch(clearRedirectURL());
    }
  }

  render() {
    // Check if we have a token (even if backend is down)
    const hasToken = this.props.token && this.props.token.length > 0;
    
    // Handle redirect to saved URL (but don't dispatch here to avoid render-time side effects)
    if (this.props.login && this.props.redirectUrl) {
      const redirectUrl = this.props.redirectUrl;
      return <Redirect to={`${redirectUrl}`} />;
    }

    const { component: Component, ...rest } = this.props.routeProps;
    
    // If we have a token but login state is false, it might be a backend connectivity issue
    // In this case, we'll show the component anyway to avoid redirect loops
    const shouldShowComponent = this.props.login || hasToken;
    
    return (
      <Route
        {...rest}
        render={(props: RouteComponentProps) => (
          shouldShowComponent ? (
            <Component {...props} />
          ) : (
            <Redirect to="/login" />
          )
        )}
      />
    );
  }
}

export default connect(mapStatetoProps)(PrivateRoute);
